export interface IViewport {
  width: number;
  height: number;
}
export function getViewport(): IViewport {
  if (typeof window !== 'undefined') {
    return { width: window.innerWidth || 0, height: window.innerHeight || 0 };
  }
  return { width: 0, height: 0 };
}
